import { create } from 'zustand'

interface PaymentState {
  isPending: boolean
  isError: boolean
  isValid: boolean
  error: string
  setPending: (pending: boolean) => void
  setError: (message: string) => void
  setValid: (valid: boolean) => void
  reset: () => void
}

export const usePaymentStore = create<PaymentState>(set => ({
  isPending: false,
  isError: false,
  isValid: false,
  error: '',
  setPending: isPending => set({ isPending }),
  setError: error => set({ isError: !!error, error }),
  setValid: isValid => set({ isValid }),
  reset: () => set({ isPending: false, isError: false, error: '' }),
}))
